import { useCallback, useState } from 'react'
import { runPostAIEditor, type AIEditorResponse, type AIEditorRequest } from '../api/ai'

export function useAIEditor() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<AIEditorResponse | null>(null)

  const run = useCallback(async (args: AIEditorRequest) => {
    setLoading(true)
    setError(null)
    try {
      const res = await runPostAIEditor(args)
      setData(res)
      return res
    } catch (e: any) {
      const msg = e?.response?.data?.detail || e?.message || 'AI request failed'
      setError(msg)
      throw new Error(msg)
    } finally {
      setLoading(false)
    }
  }, [])

  const reset = useCallback(() => { setData(null); setError(null) }, [])

  return { run, loading, error, data, reset }
}
